import React, { useState } from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import { DataSelectFilterType } from 'shared/ui/Filter/model/types';
import { SelectChangeEvent } from '@mui/material/Select';

type SelectFilterType = {
  multiple?: boolean;
  data: DataSelectFilterType[];
  label: string;
  onChange: (value: string | number[]) => void;
  style?: object;
};

export const SelectFilter = ({ multiple = false, data, onChange, style, label }: SelectFilterType) => {
  const [selected, setSelected] = useState<string>('');
  const [selectedMultiple, setSelectedMultiple] = useState<number[]>([]);

  const handleSelectedChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setSelected(value);
    onChange(value === 'all' ? '' : value);
  };

  const handleSelectedMultiple = (event: SelectChangeEvent<number[]>) => {
    const {
      target: { value },
    } = event;

    setSelectedMultiple(value as number[]);
    onChange(value);
  };

  const renderSelectedMultiple = (selected: number[]) =>
    selected
      .map((label) => {
        const selectedOption = data.find((element) => element.label === label);
        return selectedOption ? selectedOption.value : '';
      })
      .join(', ');

  return (
    <FormControl sx={style}>
      <InputLabel id="select-label">{label}</InputLabel>
      {multiple ? (
        <Select
          labelId="simple-select-label"
          multiple
          id="simple-select"
          value={selectedMultiple}
          label={label}
          onChange={handleSelectedMultiple}
          renderValue={() => renderSelectedMultiple(selectedMultiple)}
        >
          {data.map((element) => (
            <MenuItem
              key={element.label}
              value={element.label}
            >
              <Checkbox checked={selectedMultiple.includes(element.label as number)} />
              <ListItemText primary={element.value} />
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select
          labelId="simple-select-label"
          id="simple-select"
          value={selected as string}
          label={label}
          onChange={handleSelectedChange}
        >
          <MenuItem value="all">Все</MenuItem>
          {data.map((element) => (
            <MenuItem value={element.label}>{element.value}</MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};
